import {
	gsapSingleton,
	scrollTriggerSingleton
} from "../gsap";
import $ from 'jquery';
import Component from '../models/Component';
const gsap = gsapSingleton();
const ScrollTrigger = scrollTriggerSingleton();

gsap.registerPlugin(ScrollTrigger);

export default class CambioBg extends Component {
	constructor(element, context) {
		super(element, context);

		$(() => {

			const cambioBg = this.element;
			const testoRecipes = this.element.find('.testo-recipes');
			const testoHowTo = this.element.find('.testo-how-to');
			const decorationHowTo = this.element.find('.decoration-how-to');
			const newsletter =  $('body').find('.newsletter-block');
			const footer =  $('body').find('.footer-container');

			let tl;

			if (window.innerWidth > 768) {
				tl = gsap.timeline({
					scrollTrigger: {
						trigger: cambioBg,
						start: '50% bottom',
						end: '+=200',
						scrub: 1,
					}
				});
			} else {
				tl = gsap.timeline({
					scrollTrigger: {
						trigger: cambioBg,
						start: '80% bottom',
						end: '+=200',
						scrub: 1,
					}
				});
			}


			tl.to(cambioBg, {
					background: '#fff'
				})
				.to(testoRecipes, {
					color: '#6D3A1F'
				}, 0)
				.to(testoHowTo, {
					color: '#6D3A1F'
				}, 0)
				.to(decorationHowTo, {
					opacity: 0
				}, 0)
				.to(newsletter, {
					background: '#fff'
				}, 0)
				.to(footer, {
					background: '#fff'
				}, 0);
		});
	}
}
